import { Impression, ImpressionProps } from './Impression';

function toImpression(partnerId: string, props: ImpressionProps, id?: string): Impression {
  return new Impression(partnerId, props, id);
}

export { toImpression };
